// 📁 BiblePage.js
import React from "react";

function BiblePage() {
  return (
    <div className="p-6 font-sans bg-gray-100 min-h-screen">
      <h2 className="text-3xl font-semibold text-center text-gray-800">
        📖 The Bible of Roadworthiness
      </h2>
      <p className="text-lg text-center text-gray-600 mt-2 mb-6">
        Click the buttons below to view or download each document:
      </p>

      {/* Button for Guide to Maintaining Roadworthiness */}
      <button
        className="w-72 bg-blue-500 text-white p-4 mb-8 rounded-lg block mx-auto"
        onClick={() => window.open("/docs/guide-to-roadworthiness.pdf", "_blank")}
      >
        Guide to Maintaining Roadworthiness
      </button>

      {/* Button for Transport Manager's Handbook */}
      <button
        className="w-72 bg-blue-500 text-white p-4 mb-8 rounded-lg block mx-auto"
        onClick={() => window.open("/docs/transport-managers-handbook.pdf", "_blank")}
      >
        Transport Manager's Handbook
      </button>

            {/* Button for PSV Driver Handbook */}
      <button
        className="w-72 bg-blue-500 text-white p-4 mb-8 rounded-lg block mx-auto"
        onClick={() => window.open("/docs/psv-driver-handbook.pdf", "_blank")}
      >
        PSV Driver Handbook
      </button>

            {/* Button for HGV Driver Handbook */}
      <button
        className="w-72 bg-blue-500 text-white p-4 mb-8 rounded-lg block mx-auto"
        onClick={() => window.open("/docs/hgv-drivers-handbook.pdf", "_blank")}
      >
        HGV Driver Handbook
      </button>

                  {/* Button for GV79 Form */}
      <button
        className="w-72 bg-blue-500 text-white p-4 mb-8 rounded-lg block mx-auto"
        onClick={() => window.open("/docs/gv79.pdf", "_blank")}
      >
        GV79 Annex D Form
      </button>

                  {/* Button for TM1 Form */}
      <button
        className="w-72 bg-blue-500 text-white p-4 mb-8 rounded-lg block mx-auto"
        onClick={() => window.open("/docs/tm1.pdf", "_blank")}
      >
        TM1 Form
      </button>
    </div>
  );
}

export default BiblePage;
